import React from 'react';
import { useAtomValue } from 'jotai';
import { drawerAtom } from './atoms/drawer.atom';
import { ModernizationSideDrawer } from './common/modernization-side-drawer';
export const StatefulSideDrawer = () => {
  const drawerProps = useAtomValue(drawerAtom);
  return <ModernizationSideDrawer isOpen={drawerProps.isOpen ?? false} onClose={drawerProps.onClose} title={drawerProps.title} description={drawerProps.description} showDivider={drawerProps.showDivider} styles={drawerProps.styles ?? {}}>
      {drawerProps.component?.({
      onClose: drawerProps.onClose
    })}
    </ModernizationSideDrawer>;
};